---
title: Gói dịch vụ, tính năng mở rộng & hóa đơn
parent: Tài liệu
parentHref: /docs
---

<script>
  import DomainTlds from "@/components/domain-tlds.svelte"
</script>

# Gói dịch vụ, tính năng mở rộng, hóa đơn & trang pháp lý

## Một gói dịch vụ bao gồm tất cả

TOBY có một gói dịch vụ hoàn chỉnh không phí thiết lập và không có mức phí ẩn:

- **Thanh toán theo tháng hoặc theo năm:** Chọn thanh toán hàng tháng linh hoạt (có thể hủy hàng tháng bất cứ lúc nào) hoặc thanh toán theo năm tiết kiệm (cũng có thể thanh toán bằng hóa đơn). Xem [bảng giá](/vi/pricing) để biết mức giá hiện tại.

Mỗi gói đăng ký bao gồm:

- **Tên miền của riêng bạn** (<DomainTlds />) — bao gồm chuyển đổi tên miền hiện có (Domain-Umzug)
- **1 địa chỉ email** (info@...) với **hộp thư 15 GB (Maxi-Postfach)** và địa chỉ chuyển tiếp không giới hạn
- **Tối đa 15 trang** — được tạo và duy trì bằng chat, giọng nói, hoặc tải ảnh lên
- **1 ngôn ngữ bổ sung** (tổng cộng 2 ngôn ngữ) với tính năng tự động dịch khi bạn xuất bản
- **Bản tin** với **1.000 email / tháng**
- **Thống kê khách truy cập** (bảo vệ quyền riêng tư, không cần banner cookie)
- **Bộ khởi động gửi qua bưu điện** (sticker cửa và giá đỡ bàn QR A5)
- **Hosting tại EU** với bảo mật SSL tự động

## Tính năng mở rộng tùy chọn

Nếu doanh nghiệp của bạn phát triển vượt quá giới hạn đã bao gồm, bạn có thể thêm các tính năng linh hoạt bất cứ lúc nào trong **Cài đặt → Đăng ký** (có thể hủy hàng tháng, xem [bảng giá](/vi/pricing)):

- **+15 GB dung lượng email** (hoặc một hộp thư bổ sung)
- **+1 ngôn ngữ website bổ sung**
- **+15 trang bổ sung**
- **+5.000 email bản tin / tháng**

## Nhận hóa đơn doanh nghiệp chính thức (Website so với Google Play)

Nếu bạn điều hành doanh nghiệp, phòng khám, hoặc tài khoản freelancer và cần **hóa đơn doanh nghiệp chính thức có thể khấu trừ thuế (ordentliche Rechnung)** với tên công ty, địa chỉ doanh nghiệp, và VAT (MwSt.) hiển thị riêng biệt, vui lòng lưu ý nơi bạn đăng ký:

- **Đăng ký trên website (tobysite.com qua Stripe):** Bạn luôn nhận được **hóa đơn doanh nghiệp chính thức với VAT** từ chúng tôi, được gửi đến doanh nghiệp của bạn. Bạn có thể tải xuống tất cả hóa đơn trước đó và cập nhật địa chỉ thanh toán công ty của bạn bất cứ lúc nào trong **Cài đặt → Đăng ký**.
- **Đăng ký trong ứng dụng Android (Mua hàng trong ứng dụng Google Play):** Khi bạn đăng ký qua Google Play, Google xử lý thanh toán với vai trò người bán chính thức và chỉ cung cấp biên lai thanh toán Google Play tiêu chuẩn. **Chúng tôi không thể cung cấp hóa đơn VAT doanh nghiệp (ordentliche Rechnung) cho các gói đăng ký được thanh toán qua Google Play.**

> **Mẹo:** Bạn có thể đăng ký trên **tobysite.com** trong trình duyệt của bạn để nhận hóa đơn doanh nghiệp Stripe chính thức và vẫn sử dụng các ứng dụng TOBY trên Android và iOS với tài khoản của bạn mà không mất thêm chi phí.

## Thêm Thông tin xuất bản (Impressum) và Chính sách bảo mật (Datenschutz)

- **Văn bản pháp lý của riêng bạn:** Vì các yêu cầu pháp lý phụ thuộc vào cấu trúc doanh nghiệp, nghề nghiệp, và quốc gia của bạn, **TOBY không tạo ra tư vấn pháp lý hoặc viết văn bản pháp lý (Impressum hoặc Datenschutzerklärung) tự động.**
- **Cách thêm chúng:** Đơn giản là dán văn bản Thông tin xuất bản hoặc Chính sách bảo mật hiện có của bạn vào chat (hoặc tải nó lên dưới dạng tài liệu Word/PDF, hoặc yêu cầu TOBY sao chép nó từ website cũ của bạn) và nói *"Đặt cái này lên trang Thông tin xuất bản của chúng ta."* TOBY sẽ tạo các trang và liên kết chúng một cách gọn gàng trong chân trang website của bạn.
